<template>
<!--  <header class="main-header header-1 header-absolute">-->
  <header class="main-header header-1">
    <div class="top-header">
      <div class="container">
        <div class="top-header-inner">
          <div class="top-header-contacts">
            <ul class="top-header-nav">
              <li>
                <phone-number :number="config.restaurants[0].phoneNumber" :show-icon="true"/>
              </li>
            </ul>
          </div>
          <!--          <ul class="top-header-nav header-cta">-->
          <!--            <li><a href="menu-v1.html">Order Online</a></li>-->
          <!--          </ul>-->
        </div>
      </div>
    </div>

    <div class="container">
      <nav class="navbar mb-2 mt-2">
        <top-logo/>
        <top-menu :menu="menu" :is-desktop="true"/>

        <div class="header-controls">
          <!--          <ul class="header-controls-inner">-->
          <!--            <li class="cart-dropdown-wrapper cart-trigger">-->
          <!--              <span class="cart-item-count">4</span>-->
          <!--              <i class="flaticon-shopping-bag"></i>-->
          <!--            </li>-->
          <!--            <li class="search-dropdown-wrapper search-trigger">-->
          <!--              <i class="flaticon-search"></i>-->
          <!--            </li>-->
          <!--          </ul>-->
          <!-- Toggler -->
          <div class="aside-toggler aside-trigger" @click="toggleMenuState">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

      </nav>
    </div>
  </header>
</template>
<script>
import PhoneNumber from "@/views/partials/PhoneNumber";
import TopLogo from "@/views/NavigationBar/TopLogo";
import TopMenu from "@/views/NavigationBar/TopMenu";
import {mapMutations} from "vuex";

export default {
  name: 'navigation-bar',
  components: {TopMenu, TopLogo, PhoneNumber},
  data() {
    return {
      config: window.config
    }
  },
  props: {
    menu: Array
  },
  methods: {
    ...mapMutations({
      toggleMenuState: "toggleMenuState"
    })
  }
}
</script>
